import { gsap } from 'gsap';
import ScrollTrigger from 'gsap/ScrollTrigger';

gsap.registerPlugin(ScrollTrigger);

let current_page = document.documentElement.getAttribute('data-page');
let current_url = document.documentElement.getAttribute('data-url');

if (current_page === 'new-page') {

  window.adjustButtonWidth = function () {
    const contentContainer = document.querySelector('.popup-content-container');
    const headerButton = document.querySelector('.popup-header button');

    if (contentContainer && headerButton) {
      if (window.innerWidth < 976) {
        const contentWidth = contentContainer.offsetWidth;
        const contentOffset = contentContainer.getBoundingClientRect().left;
        const windowWidth = window.innerWidth;

        headerButton.style.width = `${contentWidth}px`;

        const leftOffset = contentOffset - (windowWidth - contentWidth) / 2.0;
        headerButton.style.left = `${leftOffset}px`;
      } else {
        headerButton.style.width = '';
        headerButton.style.left = '';
      }
    }
  }

  window.addEventListener('load', adjustButtonWidth);

  window.addEventListener('resize', adjustButtonWidth);

  window.updateURLWithSlug = function (slug) {
    console.log('CURRENT URL: ', current_url)
    const newUrl = current_url + '#' + slug;
    console.log(newUrl);
    window.history.pushState(null, '', newUrl);
    setTimeout(() => {
      initDividerAnimation();
    }, 100);
  }

  window.initDividerAnimation = function(slug) {

    setTimeout(() => {
      const dividers = document.querySelectorAll('.animate-divider');
      const modalContent = document.querySelector('.popup-content'); // Adjust this selector to match your modal content container

      if (!dividers.length || !modalContent) {
        return false;
      }
      const modalScroller = ScrollTrigger.create({
        scroller: modalContent,
        invalidateOnRefresh: true
      });

      modalScroller.scroll(0);

      gsap.set(dividers, { width: 0 });

      const modalTriggers = [modalScroller];

      dividers.forEach((divider, index) => {
        const trigger = ScrollTrigger.create({
          trigger: divider,
          start: 'top bottom',
          end: 'bottom top',
          scroller: modalContent,
          onEnter: () => {
            gsap.to(divider, { width: '100%', duration: 1 });
          }
        });
        modalTriggers.push(trigger);
      });

      ScrollTrigger.refresh();

      // Store modal triggers for later cleanup
      modalContent.modalTriggers = modalTriggers;
    }, 100);
  };

  $('body').on('click', function(e) {
    if ($('.popup').hasClass('modal-visible')) {
      // Check if the click is outside the popup-content-container
      if ($(e.target).closest('.popup-content-container').length === 0 &&
        !$(e.target).is('[data-close-modal="contact-form"]')) {
        closeModal();
      }
    }
  });

  $('body').on('click', '[data-close-modal="contact-form"]', function (e) {
    e.preventDefault();
    closeModal();
  });

  window.addNextNews = function(data) {

    let newsContainer = document.querySelector('.news-list');

    if (data['news-items']) {
      newsContainer.innerHTML = data['news-items'];
    }

    updateProgressWrapper(data);
    updateExploreMoreButton(data);
  }
  $(document).ready(function () {
    $('body').on('click', '.js--copy-news-url', function (e) {
      e.preventDefault();

      var tempInput = $('<input>');
      tempInput.css({
        position: 'fixed',
        left: '-9999px',
        top: '0'
      });

      $('body').append(tempInput);
      tempInput.val(window.location.href).select();
      document.execCommand('copy');
      tempInput.remove();

      var tooltip = $(this).siblings('.js--copied-tooltip-wrapper');
      tooltip.fadeIn(200).delay(2000).fadeOut(200);
    });
  });
}

function updateProgressWrapper(data) {
  let progressWrapper = document.querySelector('.news-progress-wrapper');
  let newsCounter = progressWrapper.querySelector('.news-counter');
  if (data.displayed_news_count && data.total_news_count) {
    newsCounter.innerHTML = `${data.displayed_news_count} no ${data.total_news_count}<div class="progress-bar" style="width: ${data.displayed_news_count / data.total_news_count * 100}%"></div>`;
  }
}

function updateExploreMoreButton(data) {
  let button = document.querySelector('.js--fetch-next-news');
  if (data.displayed_news_count && data.total_news_count) {
    if (data.displayed_news_count >= data.total_news_count) {
      button.style.display = 'none';
    } else {
      button.style.display = 'block';
      let nextPage = parseInt(data.page) + 1;
      button.setAttribute('data-request-query', `page:${nextPage}`);
    }
  }
}

function closeModal() {
  $('.popup').removeClass('modal-visible');
  $('html').removeClass('modal-open');
  $('#contact-form-modal-content').html('');
  history.pushState(null, null, current_url);
  const modalContent = document.querySelector('.popup-content');
  if (modalContent && modalContent.modalTriggers) {
    modalContent.modalTriggers.forEach(trigger => trigger.kill());
    modalContent.modalTriggers = [];
  }

  if (modalContent) {
    modalContent.scrollTop = 0;
  }
}
